import { CdpEuiccFindParameters, CdpEuiccFindResponse } from "../app/shared/models/layout/cdp/euicc/find/CdpEuiccFind";

export function response(params: CdpEuiccFindParameters): CdpEuiccFindResponse {
    if (params.eid) return data.find(i => i.cmd.params.eid === params.eid);
}

const data: CdpEuiccFindResponse[] = [{
    cmd: {
        success: true,
        params: {
            id: "123456789012345678901234",
            orgId: "789012345678901234567890",
            sharerOrgId: "5ea0823b1c5bd764010b9e0c",
            ownerOrgId: "5ea0823b1c5bd764010b9e0c",
            isShared: false,
            permission: "rw",
            eid: "89040024000002593200010000007090",
            sgpType: "02",
            activeIccid: "8912345678901234567890",
            fallbackIccid: "8912345678901234567891",
            profiles: [
                {
                    iccid: "8912345678901234567890"
                },
                {
                    iccid: "8912345678901234567891"
                }
            ],
            createdBy: "admin@devicewise.com",
            createdOn: "2022-06-01T12:00:00.0Z",
            updatedBy: "admin@devicewise.com",
            updatedOn: "2022-06-01T12:00:00.0Z"
        }
    }
},
{
    cmd: {
        success: true,
        params: {
            "id": "62f5030bfe2a133be4b4f00d",
            "orgId": "5ea0823b1c5bd764010b9e0c",
            "sharerOrgId": "5ea0823b1c5bd764010b9e0c",
            "ownerOrgId": "5ea0823b1c5bd764010b9e0c",
            "isShared": false,
            "permission": "rw",
            "eid": "89040024000002593200010000006023",
            "sgpType": "02",
            "createdBy": "SYSTEM",
            "createdOn": "2022-08-11T13:24:27.096Z",
            "updatedBy": "SYSTEM",
            "updatedOn": "2022-08-11T13:24:27.096Z"
        }
    }
},
{
    cmd: {
        success: true,
        params: {
            "id": "62f517d21c5bd71c93b2ad06",
            "orgId": "5ea0823b1c5bd764010b9e0c",
            "sharerOrgId": "5ea0823b1c5bd764010b9e0c",
            "ownerOrgId": "5ea0823b1c5bd764010b9e0c",
            "isShared": false,
            "permission": "rw",
            "eid": "89040024000002593200010000006605",
            "sgpType": "02",
            "fallbackIccid": "89562008019000000245",
            "profiles": [
                {
                    "iccid": "89562008019000000245"
                }
            ],
            "createdBy": "SYSTEM",
            "createdOn": "2022-08-11T14:53:06.733Z",
            "updatedBy": "SYSTEM",
            "updatedOn": "2022-08-11T14:53:06.733Z"
        }
    }
},
{
    cmd: {
        success: true,
        params: {
            "id": "62f517d21c5bd71c93b2ad06",
            "orgId": "5ea0823b1c5bd764010b9e0c",
            "sharerOrgId": "5ea0823b1c5bd764010b9e0c",
            "ownerOrgId": "5ea0823b1c5bd764010b9e0c",
            "isShared": false,
            "permission": "rw",
            "eid": "89033023312170000000005421143800",
            "sgpType": "02",
            "fallbackIccid": "89358151000000051154",
            "profiles": [
                {
                    "iccid": "89358151000000051154"
                }
            ],
            "createdBy": "SYSTEM",
            "createdOn": "2022-08-11T14:53:06.733Z",
            "updatedBy": "SYSTEM",
            "updatedOn": "2022-08-11T14:53:06.733Z"
        }
    }
}]

